
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    getUsekMezAttributes,
} from '../../reducers/project';

import projectGetActions from '../../sagas/project';

import AttributeComboBoxField from './AttributeComboBoxField.view';
import AttributeNumberField from './AttributeNumberField.view';
import UsekAttributesView from './UsekAttributes.view';

const UsekAttributesState = ({
    usekId
}) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const usekMezAttributes = useSelector(state => getUsekMezAttributes(state.project, usekId));

    const handleAttributeChange = (name, value) => {
        projectActions.setUsekAttribute(usekId, name, value);
    }

    const renderAttributes = () => {
        const ATTR_SIRKA = <AttributeNumberField
            fieldTitle="Šířka meze"
            fieldName="sirka"
            key="sirka"
            required={true}
            onChange={handleAttributeChange}
            values={usekMezAttributes}
        />;
        const ATTR_VYSKA_HORNI = <AttributeNumberField
            fieldTitle="Výška meze horní"
            fieldName="vyska_horni"
            key="vyska_horni"
            required={true}
            onChange={handleAttributeChange}
            values={usekMezAttributes}
        />;
        const ATTR_VYSKA_SPODNI = <AttributeNumberField
            fieldTitle="Výška meze spodní"
            key="vyska_spodni"
            fieldName="vyska_spodni"
            required={true}
            onChange={handleAttributeChange}
            values={usekMezAttributes}
        />;
        const ATTR_TYP_UPRAV_STAVBA = <AttributeComboBoxField
            key="typ_uprav_stavba"
            fieldTitle="Typ úprav - stavební činnost"
            fieldName="typ_uprav_stavba"
            onChange={handleAttributeChange}
            values={usekMezAttributes}
            options={[
                {key: '', text: '<< žádná >>'},
                {key: 'MB01', text: 'Zídka'},
                {key: 'MB02', text: 'Pás kamení'},
                {key: 'MB03', text: 'Val'},
                {key: 'MB04', text: 'Svah'}
            ]}
        />;
        const ATTR_TYP_UPRAV_VEGETACE = <AttributeComboBoxField
            key="typ_uprav_vegetace"
            fieldTitle="Typ úprav - vegetace"
            fieldName="typ_uprav_vegetace"
            onChange={handleAttributeChange}
            values={usekMezAttributes}
            options={[
                {key: '', text: '<< žádná >>'},
                {key: 'MV01', text: 'Travní kryt'},
                {key: 'MV02', text: 'Výsadba keřů'},
                {key: 'MV03', text: 'Výsadba stromů'}
            ]}
        />;
        const ATTR_ROZESTUP = <AttributeNumberField
            key="rozestup"
            fieldTitle="Rozestup mezi stromy nebo keři"
            fieldName="rozestup"
            required={true}
            onChange={handleAttributeChange}
            values={usekMezAttributes}
        />;

        let items = [
            ATTR_SIRKA,
            ATTR_VYSKA_HORNI,
            ATTR_VYSKA_SPODNI,
            ATTR_TYP_UPRAV_STAVBA,
            ATTR_TYP_UPRAV_VEGETACE
        ];
        if (
            (usekMezAttributes['typ_uprav_vegetace'] === 'MV02') ||
            (usekMezAttributes['typ_uprav_vegetace'] === 'MV03')) {
                items.push(ATTR_ROZESTUP);
        }
        return (
            <>
                {items}
            </>
        );
    }

    return (
        <>
            <UsekAttributesView
                usekId={usekId}
                usekAttributes={renderAttributes()}
            />
        </>
    )
}

export default UsekAttributesState;
